// extracted by mini-css-extract-plugin
export default {"CMICard":"CMICard_CMICard__d4OAy","CMICard_title":"CMICard_CMICard_title__NV6qv","CMICard_item":"CMICard_CMICard_item__BFYhk"};